import { MatchingProduct, SolutionComponent } from '../Types/MatchingProducts.ts';

/**
 * The components belonging to one specific solution.
 * The response holds the components of every matching solution in one flat list, so a solution is
 * picked out through its own ProductIds. A product id listed more than once means the solution needs
 * that many of it, so repeats are kept - solution prices and add to cart quantities build on them.
 */
export const getComponentsForSelectedSolution = (
  solutionComponents: SolutionComponent[] | null,
  matchingProducts: MatchingProduct[] | null,
  selectedSolutionIndex: number
): SolutionComponent[] => {
  if (!solutionComponents?.length) return [];

  const productIds = matchingProducts?.[selectedSolutionIndex]?.ProductIds ?? [];
  const hasMatchingProducts = productIds.length > 0;

  if ((!hasMatchingProducts || productIds.length === 1) && solutionComponents.length) {
    return solutionComponents;
  }

  return productIds
    .map((productId) => solutionComponents.find((sc) => sc.ProductId === productId))
    .filter((item): item is SolutionComponent => item != null);
};
